<template>
    <div class="lunbo">
        <van-swipe :autoplay="3000" indicator-color="white" v-if="adList.length>0">
            <van-swipe-item v-for="item in adList" >
                <img :src="item.adImgUrl" style="width:100%;height: 100%">
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId: '',
                name: '',
                adList: [],
                screenHeight:'',
            };
        },
        async created() {
            this.deptId = getDeptId()
            this.getAds()
        },
        methods: {
            async getAds() {
                let data = {
                    adType: 0,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmAds", data)
                this.adList = res.adList
            },
        },
    };
</script>

<style lang="scss" scoped>
    .lunbo{

    }

</style>
